import { format, isSameDay } from "date-fns";
import { EVENT_DATE_TYPE } from "pages/AccountSettlementHistoryOrderId/constants/EventDateType";

import type { EventDateInfo } from "pages/AccountSettlementHistoryOrderId/types/EventDateInfo";
import type { TimeStamp } from "pages/AccountSettlementHistoryOrderId/types/TimeStamp";
import type { useTranslation } from "react-i18next";

export const getReleaseDate = (
  firstPartTime: TimeStamp | null,
  lastPartTime: TimeStamp | null,
  t: ReturnType<typeof useTranslation>["t"]
): EventDateInfo => {
  if (firstPartTime === null) {
    return {
      type: EVENT_DATE_TYPE.NO_DATE,
    };
  }
  const firstDatetime = new Date(firstPartTime.seconds * 1000);
  const firstDate = format(firstDatetime, "yyyy/M/d");
  const firstDayDisplay = t(
    `common.string.dayOfWeek.${format(firstDatetime, "E")}`
  );
  const firstTime = format(firstDatetime, "HH:mm");

  const isSingleDay =
    lastPartTime === null ||
    isSameDay(firstDatetime, new Date(lastPartTime.seconds * 1000));
  if (isSingleDay) {
    return {
      type: EVENT_DATE_TYPE.SINGLE_DAY,
      openDate: `${firstDate}(${firstDayDisplay})`,
      openTime: firstTime,
    };
  }

  const lastDatetime = new Date(lastPartTime.seconds * 1000);
  const lastDate = format(lastDatetime, "yyyy/M/d");
  return {
    type: EVENT_DATE_TYPE.RANGE_DAYS,
    openDate: firstDate,
    closeDate: lastDate,
  };
};
